import { render, staticRenderFns } from "./SortDropdown.vue?vue&type=template&id=3e1537a8&scoped=true"
import script from "./SortDropdown.vue?vue&type=script&lang=js"
export * from "./SortDropdown.vue?vue&type=script&lang=js"
import style0 from "./SortDropdown.vue?vue&type=style&index=0&id=3e1537a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1537a8",
  null
  
)

export default component.exports